const pollingStations = {
  en: {
    pollingStationsPage: {
      geoUnsupported: "Geolocation is not supported by your browser",
      noneNearby: "No polling stations found within 10km. Try expanding the search area.",
      foundNearby: "Found {{count}} nearby polling stations",
      nearbyFailed: "Failed to find nearby stations",
      permissionDenied: "Location permission denied. Please enable location access.",
      positionUnavailable: "Location information unavailable",
      locationTimeout: "Location request timed out",
      locationFailed: "Failed to get location",
      fillRequired: "Please fill in all required fields",
      addSuccess: "Polling station added successfully!",
      addFailed: "Failed to add polling station",
      geoNotSupportedShort: "Geolocation not supported",
      locationCaptured: "Location captured!",
      invalidFile: "Please upload a CSV or Excel file (.csv, .xlsx, .xls)",
      importSuccess: "Successfully imported {{count}} polling stations!",
      importFailed: "Import failed",
      templateDownloaded: "Template downloaded!",
      templateFailed: "Failed to download template",
      requiredColumns: "Required columns:",
      optionalColumns: "Optional columns:",
      downloadTemplate: "Download CSV Template",
      uploadPrompt: "Click to upload or drag and drop",
      fileTypes: "CSV, Excel (.xlsx, .xls)",
      processing: "Processing file...",
      importComplete: "Import Complete",
      importedCount: "Imported: {{imported}} / {{total}} stations",
      errorsCount: "Errors ({{count}}):",
      stationNamePlaceholder: "e.g., Government School Bamenda",
      selectRegion: "Select region",
      selectDivision: "Select division",
      subdivision: "Subdivision",
      village: "Village",
      villagePlaceholder: "Village name",
      address: "Address",
      addressPlaceholder: "Street address or landmark",
      latitude: "Latitude *",
      longitude: "Longitude *",
      useCurrentLocation: "Use Current Location",
      capacity: "Capacity (voters)",
      contactPhone: "Contact Phone",
      cancel: "Cancel",
      addStationSubmit: "Add Station",
      searchPlaceholder: "Search stations...",
      allRegions: "All Regions",
      nearestStations: "Nearest Polling Stations",
      yourLocation: "Your location: {{lat}}, {{lng}}",
      searchResults: "Search Results",
      allStations: "All Polling Stations",
      stationsCount: "{{count}} stations",
      noStations: "No polling stations found",
      addFirst: "Add First Station",
      votersCount: "{{count}} voters",
    },
  },
  fr: {
    pollingStationsPage: {
      geoUnsupported: "La géolocalisation n'est pas prise en charge par votre navigateur",
      noneNearby: "Aucun bureau de vote trouvé dans un rayon de 10 km. Essayez d'élargir la zone de recherche.",
      foundNearby: "{{count}} bureaux de vote trouvés à proximité",
      nearbyFailed: "Échec de la recherche des bureaux de vote à proximité",
      permissionDenied: "Autorisation de localisation refusée. Veuillez activer l'accès à la localisation.",
      positionUnavailable: "Informations de localisation indisponibles",
      locationTimeout: "La demande de localisation a expiré",
      locationFailed: "Impossible d'obtenir la localisation",
      fillRequired: "Veuillez remplir tous les champs obligatoires",
      addSuccess: "Bureau de vote ajouté avec succès !",
      addFailed: "Échec de l'ajout du bureau de vote",
      geoNotSupportedShort: "Géolocalisation non prise en charge",
      locationCaptured: "Localisation enregistrée !",
      invalidFile: "Veuillez téléverser un fichier CSV ou Excel (.csv, .xlsx, .xls)",
      importSuccess: "{{count}} bureaux de vote importés avec succès !",
      importFailed: "Échec de l'importation",
      templateDownloaded: "Modèle téléchargé !",
      templateFailed: "Échec du téléchargement du modèle",
      requiredColumns: "Colonnes obligatoires :",
      optionalColumns: "Colonnes facultatives :",
      downloadTemplate: "Télécharger le modèle CSV",
      uploadPrompt: "Cliquez pour téléverser ou glissez-déposez",
      fileTypes: "CSV, Excel (.xlsx, .xls)",
      processing: "Traitement du fichier...",
      importComplete: "Importation terminée",
      importedCount: "Importés : {{imported}} / {{total}} bureaux",
      errorsCount: "Erreurs ({{count}}) :",
      stationNamePlaceholder: "p. ex., École publique de Bamenda",
      selectRegion: "Sélectionner la région",
      selectDivision: "Sélectionner le département",
      subdivision: "Arrondissement",
      village: "Village",
      villagePlaceholder: "Nom du village",
      address: "Adresse",
      addressPlaceholder: "Adresse postale ou point de repère",
      latitude: "Latitude *",
      longitude: "Longitude *",
      useCurrentLocation: "Utiliser ma position actuelle",
      capacity: "Capacité (électeurs)",
      contactPhone: "Téléphone de contact",
      cancel: "Annuler",
      addStationSubmit: "Ajouter le bureau",
      searchPlaceholder: "Rechercher des bureaux de vote...",
      allRegions: "Toutes les régions",
      nearestStations: "Bureaux de vote les plus proches",
      yourLocation: "Votre position : {{lat}}, {{lng}}",
      searchResults: "Résultats de la recherche",
      allStations: "Tous les bureaux de vote",
      stationsCount: "{{count}} bureaux",
      noStations: "Aucun bureau de vote trouvé",
      addFirst: "Ajouter le premier bureau",
      votersCount: "{{count}} électeurs",
    },
  },
};

export default pollingStations;
